import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CadastroService } from '../../../../../services/cadastro.service';
import { Servico } from '../../../../../models/cadastro.model';
import { CommonModule } from '@angular/common';
import { ErrorModel } from '../../../../../models/error.model';

@Component({
  selector: 'app-servicos-manutencao',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './servicos-manutencao.component.html',
  styleUrls: ['./servicos-manutencao.component.css']
})
export class ServicosManutencaoComponent implements OnInit {
  servicoForm!: FormGroup;
  servicoId: number | null = null;
  isEditMode = false;

  constructor(
    private fb: FormBuilder,
    private cadastroService: CadastroService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.servicoForm = this.fb.group({
      nome: ['', Validators.required],
      precoVenda: ['', Validators.required],
      descricao: ['']
    });

    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.isEditMode = true;
        this.servicoId = +id;
        this.loadServico(this.servicoId);
      }
    });
  }

  loadServico(id: number): void {
    this.cadastroService.getServicoById(id).subscribe(servico => {
      this.servicoForm.patchValue(servico);
    });
  }

  salvarServico(): void {
    if (this.servicoForm.valid) {
      const servicoData: Servico = { id: this.servicoId || 0, ...this.servicoForm.value };

      const operation = this.isEditMode
        ? this.cadastroService.updateServico(servicoData)
        : this.cadastroService.createServico(servicoData);

      operation.subscribe({
        next: () => {
          this.toastr.success(`Serviço ${this.isEditMode ? 'atualizado' : 'cadastrado'} com sucesso!`);
          this.router.navigate(['/home', 'cadastro-servico']);
        },
        error: (error) => {
          const erro: ErrorModel = error.error;
          this.toastr.error(erro.message);
        }
      });
    } else {
      this.toastr.error('Por favor, preencha todos os campos obrigatórios.');
    }
  }

  cancelar(): void {
    this.router.navigate(['/home', 'cadastro-servico']);
  }
}
